import * as React from 'react';

import { Field, FieldProps } from 'formik';
import { InputProps } from 'antd/lib/input';

import { FormikInput, FormikInputRenderFunc } from '@common/react/components/Forms/FormikInput/FormikInput';

export interface FormikFieldProps {
	fieldName: string;
	title?: React.ReactNode;
	render?: FormikInputRenderFunc;
	containerClass?: string;
	replaceContainerClass?: boolean;
	inputProps?: InputProps;
	required?: boolean;
}

export const FormikField = (props: FormikFieldProps): JSX.Element => {
	const containerClass = props.containerClass ?? '';

	return (
		<Field name={props.fieldName}>
			{(fieldProps: FieldProps) => (
				<FormikInput
					fieldProps={fieldProps}
					containerClassName={containerClass}
					title={props.required ? `${props.title}*` : props.title}
					render={props.render}
					inputProps={props.inputProps}
				/>
			)}
		</Field>
	);
};
